import { Link } from 'react-router-dom'
import { FinalCta } from '../components/FinalCta'
import { PageHero } from '../components/PageHero'
import { Seo } from '../components/Seo'
import { services } from '../data/services'

export function ServicesPage() {
  return (
    <>
      <Seo title="Notary & Document Services" description="Explore mobile notary, e-notary, loan signing, trust signing, I-9 verification, field inspection, courier, certified copy, and apostille assistance services." path="/services" />
      <PageHero eyebrow="Professional support, clearly explained" title="Notary and document services for the way Northwest Arkansas works." intro="From an everyday signature to a coordinated signing package or administrative document task, Michael provides a careful process and a clear next step." />
      <section className="section">
        <div className="container service-list-grid">
          {services.map((service, index) => (
            <article className="service-list-card" key={service.id}>
              <div className="service-list-top"><span>{String(index + 1).padStart(2, '0')}</span><small>{service.eyebrow}</small></div>
              <h2>{service.name}</h2>
              <p>{service.summary}</p>
              <div className="price-tag">{service.pricingSummary}</div>
              <Link className="text-link" to={`/services/${service.id}`}>What to expect <span aria-hidden="true">→</span></Link>
            </article>
          ))}
        </div>
      </section>
      <section className="section audience-section">
        <div className="container"><div className="section-heading split-heading"><div><span className="eyebrow">Who we serve</span><h2>Professional support for personal, legal, real estate, and business needs.</h2></div><p>Square &amp; Compass Notary works directly with individuals and organizations without implying exclusive or existing partnerships.</p></div><div className="audience-grid">{['Individuals and families','Real estate professionals','Law firms and legal offices','Contractors','Escrow and title professionals','Hospitals and nursing homes','Employers needing I-9 support','Businesses needing field or courier support'].map((audience) => <div key={audience}>{audience}</div>)}</div></div>
      </section>
      <FinalCta title="Not sure which service fits?" text="Describe what you need in plain language. Michael can confirm the appropriate service category, without selecting legal forms or providing legal advice." />
    </>
  )
}
